import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
} from 'react';
import t from '~t';
import debounce from '~modules/format/callback/debounce';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as coversActions from '~data/actions/covers';

import {
  Modal,
  ModalHeader as Header,
  ModalContent as Content,
  Layout,
} from '~ui';
import { Search } from '~ui';
import Items from './items';
import Add from './add';
import Reset from './reset';

let lastSearch = '';

export default function PickerIcon({ onLink, onFile, onClose }) {
  const dispatch = useDispatch();
  const { items, status } = useSelector((state) => state.covers);
  const actions = useMemo(
    () => bindActionCreators(coversActions, dispatch),
    [dispatch],
  );

  const [search, _setSearch] = useState(lastSearch);
  const setSearch = useCallback((value) => {
    lastSearch = value;
    _setSearch(value);
  }, []);

  const load = useMemo(
    () =>
      debounce(
        (value) => {
          if (!value.length || value.length > 1) actions.load(value);
        },
        250,
        { maxWait: 1000 },
      ),
    [actions],
  );

  const onSearchChange = useCallback(
    (e) => {
      const value = e.target.value;
      setSearch(value);
      load(value);
    },
    [load],
  );

  useEffect(() => {
    load(search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlers = useMemo(
    () => ({
      onLink: async (link) => {
        await onLink(link);
        onClose();
      },

      onFile: async (file) => {
        await onFile(file);
        onClose();
      },
    }),
    [onLink, onFile, onClose],
  );

  return (
    <Modal onClose={onClose} stretch>
      <Header title={t.s('changeIcon')} data-no-shadow>
        <Reset {...handlers} />
        <Add {...handlers} />
      </Header>

      <Layout>
        <Search
          autoFocus
          value={search}
          placeholder={t.s('searchIcon')}
          loading={status == 'loading'}
          onChange={onSearchChange}
        />
      </Layout>

      <Content>
        <Items items={items} status={status} {...handlers} />
      </Content>
    </Modal>
  );
}
